module.exports = __webpack_public_path__ + "static/5m-c1cf1951790396a00f2820e9383b2b3c.jpg";